import {QuestionModel} from './question.model'
import {Id} from './id.type'

export class SectionModel {
  id: Id
  form_id: Id
  name: string
  description: string
  index: number
  questions: QuestionModel[]

  constructor({form_id, name, description, questions}: any) {
    this.form_id = form_id || undefined
    this.name = name || ''
    this.description = description || ''
    this.questions = questions || []
  }
}
